function sortPinnedIds(pinnedIds: string[], a: string, b: string): number {
  return pinnedIds.indexOf(a) - pinnedIds.indexOf(b);
}

export { sortPinnedIds };
